import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CREDIT_OVERVIEW_API } from './credit-overview-api.token';
import { HttpCreditOverviewApiService } from './http/http-credit-overview-api.service';

/** Registers the live credit overview API. */
export function provideCreditOverview(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HttpCreditOverviewApiService,
    {
      provide: CREDIT_OVERVIEW_API,
      useExisting: HttpCreditOverviewApiService,
    },
  ]);
}
